export const searchInContent = (termToSearch = '', textToSearchIn = '') => {
  return termToSearch
    .toLowerCase()
    .split(/\s+/)
    .every((s) => textToSearchIn.toLowerCase().includes(s))
}
